import React, {FC, useEffect} from 'react';
import {Snackbar, Button} from '@material-ui/core';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {debug} from './common';

const ServiceWorkerWrapper: FC = () => {
  const [showReload, setShowReload] = React.useState(false);
  const [waitingWorker, setWaitingWorker] =
    React.useState<ServiceWorker | null>(null);

  const onSWUpdate = (registration: ServiceWorkerRegistration) => {
    debug('Showing reload snackbar');
    setShowReload(true);
    setWaitingWorker(registration.waiting);
  };

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: onSWUpdate,
    });
  }, []);

  const reloadPage = () => {
    debug('Version Reload Clicked');
    waitingWorker?.postMessage({type: 'SKIP_WAITING'});
    setShowReload(false);
    window.location.reload();
  };

  return (
    <Snackbar
      open={showReload}
      message="A new version is available!"
      onClick={reloadPage}
      anchorOrigin={{vertical: 'top', horizontal: 'center'}}
      style={{cursor: 'pointer'}}
      action={
        <Button color="inherit" size="small">
          Reload
        </Button>
      }
    />
  );
};

export default ServiceWorkerWrapper;
